import namespace from '@/store/namespace'
export default namespace('AclaracionComplementacionEnmienda',{
    getters:[
        'GetAclaracionCompl',
        'GetTipoSolicitud',
        'GetTipoSolicitudSeleccionado',
        'GetdatosAmpliacionesNet'
    ],
    actions:[
        'RegistrarAclaracionComplementacionEnmienda',
        'ActualizarAclaracionComplementacionEnmienda',
        'EnviarSolicitud',
        'ObtenerAclaracionComplementacionByPromocionId',
        'ObtenerAclaracionComplementacionBySolicitudId',
        'ObtenerTipoSolicitudByDominio',
        'ObtenerAclaracionesNetPorPersonaId'
    ],
    mutations:[
        'SetLstAclaracionComplNet',
        'SetAclaracionCompl',
        'SetTipoSolicitud',
        'SetTipoSolicitudSeleccAlObtener',
        'SetTipoSolicitudSeleccionado'
    ]
})